import React from "react";

import workPassportPageHeroLiveSiteReadinessPng from "../../images/work-passport-page-hero-live-site-readiness.png";
import workPassportPageHeroLiveSiteReadinessWebp from "../../images/work-passport-page-hero-live-site-readiness.webp";
import workPassportPageHeroReadyPassportCard from "../../images/work-passport-page-hero-ready-passport-card.svg";
import workPassportPageHeroLuminousVerificationBackground from "../../images/work-passport-page-hero-luminous-verification-background.svg";

import "./WorkPassportPageHero.css";

function WorkPassportPageHeroArrowIcon() {
  return (
    <svg viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M2.5 9H15M10.5 4.5L15 9L10.5 13.5"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function WorkPassportPageHero({
  demonstrationHref = "#work-passport-demonstration",
  brochureHref = "#work-passport-brochure",
}) {
  return (
    <section
      className="work-passport-page-hero"
      id="work-passport-page-top"
      aria-labelledby="work-passport-page-hero-title"
    >
      <img
        className="work-passport-page-hero__luminous-background"
        src={workPassportPageHeroLuminousVerificationBackground}
        alt=""
        aria-hidden="true"
      />

      <div className="work-passport-page-hero__inner">
        <div className="work-passport-page-hero__copy">
          <p className="work-passport-page-hero__eyebrow">
            <span aria-hidden="true" />
            Workforce compliance intelligence
          </p>

          <h1 id="work-passport-page-hero-title">
            Every worker. Every site. Ready before deployment.
          </h1>

          <p className="work-passport-page-hero__summary">
            Work Passport maps every site and position, evaluates each
            employee&apos;s live compliance record, and coordinates action
            before gaps interrupt access, productivity or operations.
          </p>

          <div className="work-passport-page-hero__actions">
            <a
              className="work-passport-page-hero__action work-passport-page-hero__action--primary"
              href={demonstrationHref}
            >
              <span>Book a demonstration</span>
              <WorkPassportPageHeroArrowIcon />
            </a>
            <a
              className="work-passport-page-hero__action work-passport-page-hero__action--secondary"
              href={brochureHref}
            >
              <span>Download brochure</span>
              <WorkPassportPageHeroArrowIcon />
            </a>
          </div>

          <ul className="work-passport-page-hero__proof" aria-label="System qualities">
            <li><i className="work-passport-page-hero__proof-dot work-passport-page-hero__proof-dot--blue" />Site-specific</li>
            <li><i className="work-passport-page-hero__proof-dot work-passport-page-hero__proof-dot--pink" />Role-specific</li>
            <li><i className="work-passport-page-hero__proof-dot work-passport-page-hero__proof-dot--green" />Expiry-aware</li>
          </ul>
        </div>

        <div className="work-passport-page-hero__visual" aria-label="Work Passport readiness verification example">
          <picture>
            <source
              srcSet={workPassportPageHeroLiveSiteReadinessWebp}
              type="image/webp"
            />
            <img
              className="work-passport-page-hero__site-photo"
              src={workPassportPageHeroLiveSiteReadinessPng}
              alt="A worker and site coordinator checking a digital readiness pass at an industrial site entrance"
            />
          </picture>

          <span className="work-passport-page-hero__live-status">
            <i aria-hidden="true" />
            Live readiness check
          </span>

          <img
            className="work-passport-page-hero__passport-card"
            src={workPassportPageHeroReadyPassportCard}
            alt="Example Work Passport showing an employee ready for deployment"
          />
        </div>
      </div>
    </section>
  );
}
